import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  validationError,
  ValidationMessagesKeys,
} from './Configs/validationMessages.config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'validations',
  templateUrl: 'validations.component.html',
  styleUrls: ['validations.component.scss'],
})
export class ValidationsComponent {
  @Input() control!: FormControl;

  constructor(private translate: TranslateService) {}

  public get errorsKeys(): Array<any> {
    if (this.control?.errors) {
      return Object.keys(this.control?.errors).map((key) => {
        return { error: key, value: this.control?.errors![key] };
      });
    }
    return [];
  }

  public errorMessage(errorKey: { error: string; value: any }) {
    let validationErrorMessage: { ar: string; en: string };

    if (errorKey && errorKey.error) {
      const validationMessage =
        ValidationMessagesKeys[
          errorKey.error as keyof typeof ValidationMessagesKeys
        ];
      if (typeof validationMessage === 'function') {
        switch (errorKey.error) {
          case validationError.minlength:
          case validationError.maxlength:
            validationErrorMessage = validationMessage(
              errorKey.value.requiredLength
            );
            break;
          case validationError.min:
            validationErrorMessage = validationMessage(errorKey.value.min);
            break;
          case validationError.max:
            validationErrorMessage = validationMessage(errorKey.value.max);
            break;
          case validationError.phoneNumberVaidation:
            validationErrorMessage = validationMessage(
              errorKey.value.validatePhoneNumber
            );
            break;
          default:
            validationErrorMessage = validationMessage(errorKey.value);
        }
      } else {
        validationErrorMessage = validationMessage;
      }
      return this.translate.currentLang === 'ar'
        ? validationErrorMessage.ar
        : validationErrorMessage.en;
    }
    return null;
  }
}
